import { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useNewTag } from 'shared/hooks/useNewTag'

import { TRouterParams } from 'shared/types'
import { useNotifications } from 'modulesCommon/Notifications/services'
import { TStory } from '../../../components/Story'

const useNewStoryNotification = (story: TStory) => {
  const storyBottomRef = useRef(null)
  const { id } = useParams<TRouterParams>()

  const { getNotifications } = useNotifications()

  const { deleteNotificationsHandler, isExistInNotifications } = useNewTag(storyBottomRef, story, getNotifications())

  return {
    storyBottomRef,
    storyRef: storyBottomRef,
    id,
    deleteNotificationsHandler,
    isExistInNotifications
  }
}

export default useNewStoryNotification
